import React, { Fragment, useState } from 'react';

import cx from 'classnames';

import './slider.css';

const Slider = () => {
    const slides = [
        './images/index/slider/R1-00225-0004.jpg',
        './images/index/slider/R1-00225-0005.jpg',
        './images/index/slider/R1-00225-0011.jpg',
        './images/index/slider/R1-00225-0012.jpg',
        './images/index/slider/R1-00225-0015.jpg',
        './images/index/slider/R1-00225-0016.jpg',
        './images/index/slider/R1-00225-0019.jpg',
        './images/index/slider/R1-00225-0020.jpg',
        './images/index/slider/R1-00225-0022.jpg',
        './images/index/slider/R1-00225-0033.jpg',
        './images/index/slider/R1-00225-0035.jpg',
        './images/index/slider/R1-00225-0036.jpg',
        './images/index/slider/R1-00226-0001.jpg',
        './images/index/slider/R1-00226-0002.jpg',
        './images/index/slider/R1-00226-0003.jpg',
        './images/index/slider/R1-00226-0004.jpg',
        './images/index/slider/R1-00226-0006.jpg',
        './images/index/slider/R1-00226-0007.jpg',
        './images/index/slider/R1-00226-0011.jpg',
        './images/index/slider/R1-00226-0014.jpg',
        './images/index/slider/R1-00226-0015.jpg',
        './images/index/slider/R1-00226-0016.jpg',
        './images/index/slider/R1-00226-0017.jpg',
        './images/index/slider/R1-00226-0019.jpg',
        './images/index/slider/R1-00226-0021.jpg',
        './images/index/slider/R1-00226-0022.jpg',
        './images/index/slider/R1-00226-0023.jpg'
    ];
    const [active, setActive] = useState(0);

    const setActiveMod = (arg) => {
        let newActive = (active + arg) % slides.length;
        if (newActive < 0) {
            newActive += slides.length;
        }

        setActive(newActive);
    };

    const goRight = () => setActiveMod(+1);
    const goLeft = () => setActiveMod(-1);

    return (
        <Fragment>
            <div className="slider">
                <img
                    alt="show previous slide"
                    className="slider__arrow slider__arrow_left"
                    onClick={goLeft}
                    src="./images/index/arrow-left.svg"
                />
                <img
                    alt={`slide ${slides[active]}`}
                    className="slider__slide"
                    src={slides[active]}
                />
                <img
                    alt="show next slide"
                    className="slider__arrow slider__arrow_right"
                    onClick={goRight}
                    src="./images/index/arrow-right.svg"
                />
            </div>
            <div className="slider__circles">
                {slides.map((element, index) => (
                    <div
                        className={cx('slider__circle', {
                            slider__circle_active: index === active
                        })}
                        key={element}
                        onClick={() => setActive(index)}
                    />
                ))}
            </div>
        </Fragment>
    );
};

export default Slider;
